import React from 'react';
import { DateTimeInput } from '../controls/DateTimeInput';

interface TimelineItemProps {
  id: string;
  name: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  error?: string;
  editable?: boolean;
  minValue?: string;
  isLast?: boolean;
  showDelta?: boolean;
  deltaValue?: string;
  colors: {
    indicator: string;
    border: string;
    text: string;
    line?: string;
  };
  formatDisplayTime: (value: string) => string;
  formatTimezoneDisplay: (value: string) => string;
}

const TimelineItem: React.FC<TimelineItemProps> = ({
  id,
  name,
  label,
  value,
  onChange,
  error,
  editable = false,
  minValue,
  isLast = false,
  showDelta = false,
  deltaValue,
  colors,
  formatDisplayTime,
  formatTimezoneDisplay,
}) => {
  return (
    <div className={`relative pl-10 ${!isLast ? 'pb-2' : ''}`}>
      {/* Vertical line */}
      {!isLast && (
        <div className={`absolute left-2 w-0.5 mx-[6px] top-1 -bottom-1 ${colors.line ?? 'bg-blue-200'}`}></div>
      )}

      {/* Delta time display */}
      {showDelta && deltaValue && (
        <div className="absolute left-[6px] top-2/3 transform -translate-y-1/2 text-xs text-dataops-yale-blue bg-white px-1 rounded-full ring-1 ring-dataops-taupe-gray/20">
          {deltaValue}
        </div>
      )}

      {/* Timeline indicator */}
      <div className={`absolute left-[9px] w-3 h-3 rounded-full ${colors.indicator} ${colors.border} mt-1`}></div>

      {/* Content */}
      <div className="text-sm">
        {editable ? (
          <div className="w-64">
            <DateTimeInput
              id={id}
              name={name}
              label={label}
              value={value}
              onChange={(e) => {
                onChange(e.target.value);
              }}
              error={error}
              required
              className="mb-2"
              min={minValue}
            />
          </div>
        ) : (
          <>
            <span className={`font-medium ${colors.text}`}>{label}</span>
            <div className="text-gray-600">{formatDisplayTime(value)}</div>
          </>
        )}
      </div>
    </div>
  );
};

export default TimelineItem;
